import {ssrSafeDocument} from '@github-ui/ssr-utils'
import {useClientValue} from '@github-ui/use-client-value'
import {Button} from '@primer/react'
import {Dialog} from '@primer/react/deprecated'
import {createPortal} from 'react-dom'

import styles from './CheckTagNameDialog.module.css'

export function CheckTagNameDialog({
  isOpen,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean
  onDismiss: () => void
  onConfirm: () => void
}) {
  const [body] = useClientValue<HTMLElement | null>(() => document.body, null, [ssrSafeDocument?.body])

  return body
    ? createPortal(
        <Dialog isOpen={isOpen} onDismiss={onDismiss}>
          <Dialog.Header>Create branch</Dialog.Header>
          <div className="pr-p-3">
            <span>
              A tag already exists with the provided branch name. Many Git commands accept both tag and branch names, so
              creating this branch may cause unexpected behavior. Are you sure you want to create this branch?
            </span>
            <div className={styles.DialogFooterButtons}>
              <Button onClick={onDismiss}>Cancel</Button>
              <Button variant="danger" onClick={onConfirm} className="ml-2">
                Create
              </Button>
            </div>
          </div>
        </Dialog>,
        document.body,
      )
    : null
}
